import PropTypes from "prop-types";
import React from "react";
import Button from "../../components/Button/Button";
import Button2 from "../../components/Button/Button2";
import { Field } from "formik";
import FormInput2 from "../../components/FormInput/FormInput2";
import Loader from "../../components/Loader/Loader";
import ReCAPTCHA from "react-google-recaptcha";

export const SignUpForm4 = (props) => {
  const { page3, isValid, dirty, isRegistering, block3, setState, state } = props;

  const recaptchaRef = React.createRef();
  const siteKey = process.env.REACT_APP_API_SITE_KEY

  function validateEmail(value) {
    let error;
    if (!value) {
      error = 'Email is required';
    } else if (!value.match(/\S+@\S+\.\S+/)) {
      error = 'Email is invalid';
    }
    return error;
  }

  const onChange = (value) => {
    setState({
      ...state,
      captha: value
    })
  }

  const emptyCaptha = () => {
    setState({
      ...state,
      captha: ""
    })
  }

  return (
    <div className="form-1">
      <div className="form-input">
        <Field
          name="network_manager_firstname"
          label="Network Admin First Name"
          type="text"
          placeholder="Enter first name"
          component={FormInput2}
        />
      </div>

      <div className="form-input">
        <Field
          name="network_manager_lastname"
          label="Network Admin Last Name"
          type="text"
          placeholder="Enter last name"
          component={FormInput2}
        />
      </div>

      <div className="form-input">
        <Field
          name="network_manager_email"
          label="Network Admin Email"
          placeholder="Enter email"
          validate={validateEmail}
          component={FormInput2}
        />
      </div>

      <div className="form-input">
        <Field
          name="network_manager_phone"
          label="Network Admin Phone Number"
          placeholder="Enter phone number"
          component={FormInput2}
        />
      </div>

      <div className="form-input">
        <br/>
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={siteKey}
          onChange={onChange}
          onExpired={emptyCaptha}
        />
      </div>

      <div className="form-input-button">
        <Button2 width="45%" height="45px" word={"Back"} onClick={page3} />
        <Button
          type="submit"
          width="45%"
          height="45px"
          word={"Proceed"}
          disabled={block3 || !(isValid && dirty) || isRegistering || state.captha === ""}
          img={isRegistering ? <Loader /> : ""}
        />
      </div>
    </div>
  );
};

SignUpForm4.propTypes = {
  block3: PropTypes.any,
  dirty: PropTypes.any,
  isRegistering: PropTypes.any,
  isValid: PropTypes.any,
  page3: PropTypes.any,
  setState: PropTypes.func,
  state: PropTypes.shape({
    captha: PropTypes.string
  })
}

export default SignUpForm4;
